const FORBIDDEN_PATH_KEYS = /* @__PURE__ */ new Set(["__proto__", "constructor", "prototype"]);
export {
  FORBIDDEN_PATH_KEYS
};
